export const africanCodes = [
  'DZ',
  'AO',
  'BJ',
  'BW',
  'BF',
  'BI',
  'CM',
  'CV',
  'CF',
  'TD',
  'KM',
  'CD',
  'DJ',
  'EG',
  'GQ',
  'ER',
  'ET',
  'GA',
  'GM',
  'GH',
  'GN',
  'GW',
  'CI',
  'KE',
  'LS',
  'LR',
  'LY',
  'MG',
  'MW',
  'ML',
  'MR',
  'MU',
  'YT',
  'MA',
  'MZ',
  'NA',
  'NE',
  'NG',
  'CG',
  'RE',
  'RW',
  'SH',
  'ST',
  'SN',
  'SC',
  'SL',
  'SO',
  'ZA',
  'SS',
  'SD',
  'SZ',
  'TZ',
  'TG',
  'TN',
  'UG',
  'EH',
  'ZM',
  'ZW',
]

export const africanNationalities = [
  'Algerian',
  'Angolan',
  'Beninese, Beninois',
  'Motswana, Botswanan',
  'Burkinabé',
  'Burundian',
  'Cabo Verdean',
  'Cameroonian',
  'Central African',
  'Chadian',
  'Comoran, Comorian',
  'Congolese',
  'Congolese',
  'Ivorian',
  'Djiboutian',
  'Egyptian',
  'Equatorial Guinean, Equatoguinean',
  'Eritrean',
  'Ethiopian',
  'Gabonese',
  'Gambian',
  'Ghanaian',
  'Guinean',
  'Bissau-Guinean',
  'Kenyan',
  'Basotho',
  'Liberian',
  'Libyan',
  'Malagasy',
  'Malawian',
  'Malian, Malinese',
  'Mauritanian',
  'Mauritian',
  'Mahoran',
  'Moroccan',
  'Mozambican',
  'Namibian',
  'Nigerien',
  'Nigerian',
  'Réunionese, Réunionnais',
  'Rwandan',
  'Saint Helenian',
  'São Toméan',
  'Senegalese',
  'Seychellois',
  'Sierra Leonean',
  'Somali, Somalian',
  'South African',
  'South Sudanese',
  'Sudanese',
  'Swazi',
  'Tanzanian',
  'Togolese',
  'Tunisian',
  'Ugandan',
  'Sahrawi, Sahrawian, Sahraouian',
  'Zambian',
  'Zimbabwean',
]
